import {
  getOffersClient,
  makeAuthenticatedQuery,
} from '@b-stock/fe-core/bstock-next/queries'
import { buildAxiosRequestConfig } from '@b-stock/fe-core/bstock-react'

const findOffers = async (
  accessToken: string,
  {
    offeringId,
  }: {
    offeringId: string
  }
) => {
  const client = getOffersClient()

  const response = await client.findOffers(
    { offeringId: [offeringId] },
    buildAxiosRequestConfig({ accessToken })
  )

  return response.data
}

export const findOffersQuery = makeAuthenticatedQuery('findOffers', findOffers)
